/* Northpaw theme JS — behavior ported from the client mockups in _reference/.
   No frameworks; progressively enhances server-rendered markup. */

(function () {
  'use strict';

  /* ---------- Notify modal (shared: species card + product-grid Notify Me) ----------
     The mockup's submit was a placeholder setTimeout. Here the form is a real
     Shopify customer form ({% form 'customer' %} in snippets/northpaw-notify-modal.liquid):
     it POSTs to Shopify, which creates the customer with marketing consent and
     the notify:<product> tag, then redirects back with ?customer_posted=true. */
  var modal = document.getElementById('NotifyModal');

  if (modal) {
    var modalContext = document.getElementById('NotifyContext');
    var modalForm = document.getElementById('NotifyForm');
    var modalSuccess = document.getElementById('NotifySuccess');
    var tagsInput = document.getElementById('NotifyTags');
    var closeBtn = document.getElementById('NotifyClose');
    var lastTrigger = null;

    var openNotify = function (label, trigger) {
      lastTrigger = trigger || null;
      if (label && modalContext) {
        modalContext.textContent = 'Be the first to know when ' + label + ' launches.';
      }
      if (tagsInput && label) {
        tagsInput.value = 'notify-launch, notify:' + label;
      }
      modal.classList.add('open');
      modal.removeAttribute('aria-hidden');
      var emailField = modal.querySelector('input[type=email]');
      if (emailField && modalForm && modalForm.style.display !== 'none') emailField.focus();
      else if (closeBtn) closeBtn.focus();
    };

    var closeNotify = function () {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      if (lastTrigger) lastTrigger.focus();
    };

    document.querySelectorAll('[data-notify]').forEach(function (el) {
      el.addEventListener('click', function () {
        openNotify(el.getAttribute('data-notify'), el);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeNotify);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeNotify();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeNotify();
    });

    // Basic focus containment while the dialog is open.
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = modal.querySelectorAll('button, input, [href]');
      var visible = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null;
      });
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // After Shopify processes the customer form it redirects back with
    // ?customer_posted=true — reopen the modal in its success state.
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      if (modalForm) modalForm.style.display = 'none';
      if (modalSuccess) modalSuccess.style.display = 'block';
      openNotify(null, null);
    }
  }

  /* ---------- FAQ accordion: only one item open at a time (mockup behavior) ---------- */
  document.querySelectorAll('[data-np-faq]').forEach(function (container) {
    var items = container.querySelectorAll('details.np-acc-item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  /* ---------- PDP: quantity stepper ---------- */
  document.querySelectorAll('[data-np-qty]').forEach(function (qty) {
    var input = qty.querySelector('input');
    var decr = qty.querySelector('[data-qty-decr]');
    var incr = qty.querySelector('[data-qty-incr]');
    if (!input) return;
    if (decr) decr.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
      input.dispatchEvent(new Event('change'));
    });
    if (incr) incr.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- PDP: subscription selector ----------
     Radios are rendered from the product's real selling plans (Recharge/Skio
     create these). The next-charge date is computed live: today + the plan's
     delivery interval, parsed from the selling plan's option value
     (e.g. "90 Days"). Nothing is hardcoded; if the interval can't be parsed,
     the date line is hidden rather than faked. */
  document.querySelectorAll('[data-np-sub-box]').forEach(function (box) {
    var form = document.getElementById(box.getAttribute('data-form-id'));
    var sellingPlanInput = form ? form.querySelector('input[name="selling_plan"]') : null;
    var addBtn = form ? form.querySelector('[data-np-add-label]') : null;
    var radios = box.querySelectorAll('input[type=radio][name="np-purchase-option"]');

    // Fill in each subscription option's computed next-charge date.
    box.querySelectorAll('[data-next-charge][data-interval]').forEach(function (el) {
      var m = (el.getAttribute('data-interval') || '').match(/(\d+)\s*(day|week|month|year)/i);
      if (!m) { el.hidden = true; return; }
      var n = parseInt(m[1], 10);
      var unit = m[2].toLowerCase();
      var d = new Date();
      if (unit === 'day') d.setDate(d.getDate() + n);
      else if (unit === 'week') d.setDate(d.getDate() + n * 7);
      else if (unit === 'month') d.setMonth(d.getMonth() + n);
      else d.setFullYear(d.getFullYear() + n);
      var formatted = d.toLocaleDateString(document.documentElement.lang || 'en', {
        month: 'short', day: 'numeric', year: 'numeric'
      });
      el.textContent = 'Next charge: ' + formatted + '.';
    });

    var applySelection = function (radio) {
      if (sellingPlanInput) sellingPlanInput.value = radio.getAttribute('data-selling-plan-id') || '';
      var priceFormatted = radio.getAttribute('data-price-formatted');
      if (addBtn) {
        addBtn.textContent = priceFormatted
          ? addBtn.getAttribute('data-label-base') + ' — ' + priceFormatted
          : addBtn.getAttribute('data-label-base');
      }
      var stickyPrice = document.querySelector('[data-np-sticky-price]');
      if (stickyPrice && priceFormatted) stickyPrice.textContent = priceFormatted;
    };

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { applySelection(radio); });
    });
    var checked = box.querySelector('input[type=radio][name="np-purchase-option"]:checked');
    if (checked) applySelection(checked);

    // Clicking anywhere in the row selects its radio (mockup behavior);
    // labels already do this natively, so this is just insurance for the padding area.
    box.querySelectorAll('.np-sub-option').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var radio = row.querySelector('input[type=radio]');
        if (radio && e.target !== radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  /* ---------- PDP: sticky buy bar ----------
     Shows once the main Add to Cart button leaves the viewport; its button
     submits the main product form, so the selected plan/quantity apply. */
  var stickyBar = document.querySelector('[data-np-sticky]');
  var mainAddBtn = document.querySelector('[data-np-add-label]');
  if (stickyBar && mainAddBtn && 'IntersectionObserver' in window) {
    var stickyBtn = stickyBar.querySelector('button');
    new IntersectionObserver(function (entries) {
      var passed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      stickyBar.classList.toggle('visible', passed);
      stickyBar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = passed ? 0 : -1;
    }, { threshold: 0 }).observe(mainAddBtn);
  }

  /* ---------- PDP: gallery thumbnails (click to swap main image) ---------- */
  document.querySelectorAll('[data-np-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('.np-gallery__main img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.np-thumb'));
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (thumb.getAttribute('data-full-src')) {
          // Clear any stale srcset first, otherwise the browser keeps rendering the
          // original featured image and ignores the new src (the "stuck" bug).
          mainImg.srcset = thumb.getAttribute('data-full-srcset') || '';
          mainImg.src = thumb.getAttribute('data-full-src');
        }
        if (thumb.getAttribute('data-alt') !== null) mainImg.alt = thumb.getAttribute('data-alt');
      });
    });
  });
})();
